import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Auth0Provider } from '@auth0/auth0-react';

const domain = (process.env.REACT_APP_AUTH0_DOMAIN || "").trim();
const clientId = (process.env.REACT_APP_AUTH0_CLIENT_ID || "").trim();
const audience = (process.env.REACT_APP_AUTH0_AUDIENCE || "").trim();

const root = ReactDOM.createRoot(document.getElementById('root'));
const safeInternalReturnTo = (value) => {
  if (typeof value !== "string" || !value.startsWith("/") || value.startsWith("//")) {
    return window.location.pathname;
  }
  try {
    const url = new URL(value, window.location.origin);
    if (url.origin !== window.location.origin) return window.location.pathname;
    return `${url.pathname}${url.search}${url.hash}`;
  } catch {
    return window.location.pathname;
  }
};
root.render(
  <React.StrictMode>
    <Auth0Provider
      domain={domain}
      clientId={clientId}
      authorizationParams={{
        redirect_uri: window.location.origin,
        audience: audience,
        // offline_access is REQUIRED for Auth0 to issue a refresh token.
        // Without it, useRefreshTokens has nothing to use and silent token
        // calls fail with "missing_refresh_token".
        scope: "openid profile email offline_access"
      }}
      // After Auth0 returns, honor a same-origin appState.returnTo such as the
      // free-exam handoff route. Normal logins pass no appState, so this strips
      // Auth0 query params from the current path.
      onRedirectCallback={(appState) => {
        const target = safeInternalReturnTo(appState && appState.returnTo);
        window.history.replaceState({}, document.title, target);
        const event = typeof PopStateEvent === "function"
          ? new PopStateEvent("popstate", { state: window.history.state })
          : new Event("popstate");
        window.dispatchEvent(event);
      }}
      cacheLocation="localstorage"
      useRefreshTokens={true}
      useRefreshTokensFallback={true}
    >
      <App />
    </Auth0Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
